var _rect, _rect2, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMetricIconIncomplete(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    fill: "#E5F2F2"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 1.85527,
    y: 1.85524,
    width: 33.7105,
    height: 33.7105,
    rx: 7.21241,
    stroke: "#F2F8F8",
    strokeWidth: 3.71054
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M10.7227 23.2235C10.9429 25.2817 12.5982 26.937 14.6553 27.1662C16.1832 27.3365 17.752 27.4828 19.3515 27.4828C20.9509 27.4828 22.5197 27.3365 24.0476 27.1662C26.1048 26.937 27.76 25.2817 27.9802 23.2235C28.1428 21.7043 28.28 20.1445 28.28 18.5542C28.28 16.964 28.1428 15.4042 27.9802 13.8849C27.76 11.8268 26.1048 10.1715 24.0476 9.94226C22.5197 9.77195 20.9509 9.62567 19.3515 9.62567C17.752 9.62567 16.1832 9.77195 14.6553 9.94226C12.5982 10.1715 10.9429 11.8268 10.7227 13.8849C10.5602 15.4042 10.4229 16.964 10.4229 18.5542C10.4229 20.1445 10.5602 21.7043 10.7227 23.2235Z",
    fill: "#CAE4E4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.7227 23.2235C10.9429 25.2817 12.5982 26.937 14.6553 27.1662C16.1832 27.3365 17.752 27.4828 19.3515 27.4828C20.9509 27.4828 22.5197 27.3365 24.0476 27.1662C26.1048 26.937 27.76 25.2817 27.9802 23.2235C28.1428 21.7043 28.28 20.1445 28.28 18.5542C28.28 16.964 28.1428 15.4042 27.9802 13.8849C27.76 11.8268 26.1048 10.1715 24.0476 9.94226C22.5197 9.77195 20.9509 9.62567 19.3515 9.62567C17.752 9.62567 16.1832 9.77195 14.6553 9.94226C12.5982 10.1715 10.9429 11.8268 10.7227 13.8849C10.5602 15.4042 10.4229 16.964 10.4229 18.5542C10.4229 20.1445 10.5602 21.7043 10.7227 23.2235Z",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.7105 15.7107L22.7818 21.7819M22.7818 15.7105L16.7106 21.7817",
    stroke: "#219798",
    strokeWidth: 1.42857,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMetricIconIncomplete);
export default __webpack_public_path__ + "static/media/MetricIconIncomplete.7e706940293df49e92feb601a20736b4.svg";
export { ForwardRef as ReactComponent };